export enum SupportArticles {
  HOW_TO_CONTACT_SUPPORT = "HOW_TO_CONTACT_SUPPORT",
  SIGN_IC_AGREEMENT = "SIGN_IC_AGREEMENT",
  REFERRAL_BONUS = "REFERRAL_BONUS",
  WHY_WORKERS_SEE_QUIZ = "WHY_WORKERS_SEE_QUIZ",
  EDITING_CLOCK_IN_AND_OUT_TIMES = "EDITING_CLOCK_IN_AND_OUT_TIMES",
  CLOCKING_IN_WITH_NFC_TAGS = "CLOCKING_IN_WITH_NFC_TAGS",
  DYNAMIC_PENALTIES = "DYNAMIC_PENALTIES",
  BREAK_PAYMENT_REQUESTS = "BREAK_PAYMENT_REQUESTS",
  PAPER_TIMESHEET_INSTRUCTIONS = "PAPER_TIMESHEET_INSTRUCTIONS",
  SHIFT_BLOCKS = "SHIFT_BLOCKS",
  SKILLS_ASSESSMENT_CONFIG = "SKILLS_ASSESSMENT_CONFIG",
  REFERRAL_SHIFT_ATTENDANCE_RATE = "REFERRAL_SHIFT_ATTENDANCE_RATE",
  AFFILIATE_GUIDE = "AFFILIATE_GUIDE",
  REFERRAL_GUIDE = "REFERRAL_GUIDE",
  REFERRAL_POLICY = "REFERRAL_POLICY",
}

export enum SupportContext {
  ONBOARDING_ERROR = "Onboarding Error",
  ONBOARDING_CHECKR_ERROR = "Onboarding Checkr Error",
  NO_USER_SCREEN = "No User Screen",
  LOGIN_OTP_DELIVERY = "Login OTP Delivery",
  SIGN_UP_OTP_DELIVERY = "Signup OTP Delivery",
  AGENTPROFILE_FETCH_ERROR = "Agentprofile Fetch Error",
  ERROR_FALLBACK_SCREEN = "Error Fallback Screen",
  PDF_LOAD_FAILURE = "Pdf Load Failure",
  UNSUPPORTED_PDF_PLATFORM = "Unsupported Pdf Platform",
  NO_WORKER_AGREEMENT_FILE_AVAILABLE = "No Worker Agreement File Available",
  NO_AGREEMENT_TEMPLATE_FILE_AVAILABLE = "No Agreement Template File Available",
  IC_AGREEMENT_ERROR_ALERT = "IC Agreement Error Alert",
  JOB_SEARCH_AGREEMENT = "Job Search Agreement",
  PHONE_LOGIN_WITH_FACILITY_MOBILE_APP_INSTEAD = "Phone Login With Facility Mobile App Instead",
  EMAIL_LOGIN_WITH_FACILITY_MOBILE_APP_INSTEAD = "Email Login With Facility Mobile App Instead",
  NO_REFERRAL_PROGRAM = "Not eligible for any referral program",
  WORKER_REFERRALS = "Worker Referrals",
  SHARED_SHIFT_NOT_FOUND = "Shift Not Found",
  DOCUMENTS_ERROR = "Documents Error",
  ACCEPT_SHIFT_TRANSFER_ERROR = "Accept Shift Transfer Error",
  WORKPLACE_QUIZ_ERROR = "Error in Workplace submit",
}

export const DEFAULT_SUPPORT_LINKS = {
  HOW_TO_CONTACT_SUPPORT:
    "https://workers.clipboardhealth.com/hc/en-us/articles/29560123592727-How-do-I-contact-support",
  WHY_SSN:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34205857225751-Why-Does-Clipboard-Request-My-Social-Security-Number-SSN",
  HELP_CENTER_WORKER: "https://workers.clipboardhealth.com/",
  BACKGROUND_CHECKS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34205715271831-Understanding-Background-Checks",
  TIMESHEET_SIGNATURES:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207430665623-How-to-Submit-a-Paper-Timesheet",
  ATTENDANCE_SCORE:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207842702743-Understanding-Your-Clipboard-Score",
  DNR_REQUESTS_WORKER:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34208279646871-What-It-Means-to-Be-Placed-on-a-Do-Not-Return-DNR-List",
  MULTI_STATE_LICENSES:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34205635416087-How-Multi-State-Licenses-Work-for-Healthcare-Professionals",
  WORK_WITH_FRIENDS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34206113173911-How-to-Use-Work-with-Friends-and-Manage-Your-Connections-on-Clipboard",
  RATE_NEGOTIATION_WORKER:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34206274318743-How-to-Use-Rate-Negotiation-When-Booking-Shifts",
  REFERRAL_BONUS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/29561079313175-Do-you-have-a-referral-program",
  SUSPENSION_AND_DEACTIVATION_RULES:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34208101399447",
  INSTANT_PAY_INFO:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207219601431-How-to-Update-or-Troubleshoot-Your-Payment-Information-on-Stripe",
  EXTRA_WORK_BREAKS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207475650583-How-to-Manage-Your-Break-Times-During-a-Shift",
  EDITING_CLOCK_IN_AND_OUT_TIMES:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207475650583-How-to-Manage-Your-Break-Times-During-a-Shift#h_01K0S7YP8146ZMQW82BFGR87XX",
  CLOCKING_IN_WITH_NFC_TAGS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207439089431-How-to-Use-NFC-Time-Clock-Posters-to-Clock-In-and-Out",
  DYNAMIC_PENALTIES:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207842702743-Understanding-Your-Clipboard-Score",
  PRIORITY_ACCESS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/29561053580567-How-Priority-Access-Works",
  BREAK_PAYMENT_REQUESTS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207475650583-How-to-Manage-Your-Break-Times-During-a-Shift",
  PAPER_TIMESHEET_INSTRUCTIONS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207430665623-How-to-Submit-a-Paper-Timesheet",
  SHIFT_BLOCKS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34206280276119-How-Block-Booking-Works",
  SKILLS_ASSESSMENT_CONFIG:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34205912093463-How-to-Complete-the-Clipboard-Demo-Shift-Before-Booking-Your-First-Shift",
  REFERRAL_SHIFT_ATTENDANCE_RATE:
    "https://workers.clipboardhealth.com/hc/en-us/articles/29559870622999-Shift-Attendance-Rate",
  AFFILIATE_GUIDE:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34206088299799-How-to-Refer-Workplaces-Through-the-Affiliate-Program",
  REFERRAL_GUIDE:
    "https://workers.clipboardhealth.com/hc/en-us/articles/30477734725143-Facility-Referrals-Guide",
  REFERRAL_POLICY:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34206088299799-How-to-Refer-Workplaces-Through-the-Affiliate-Program",
  WHY_WORKERS_SEE_QUIZ:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34205775308439-What-Is-the-Workplace-Rules-Quiz-Before-Booking-a-Shift",
  CLIPBOARD_SCORE:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207842702743-Understanding-Your-Clipboard-Score",
  LIMITED_STATUS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34444110519447-Why-is-my-account-in-Limited-status",
  IN_HOME_FAQ:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34205970215191-How-Clipboard-In-Home-Works",
  IN_HOME_DEMO: "https://www.loom.com/share/3a1bcacbda1042cba9fdd9254643e267",

  PLACEMENT_CLAIM_SIGN_ON_BONUS:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34217412168599-How-to-Claim-Your-Gift-After-Getting-Hired-Through-Clipboard-Jobs",
  PLACEMENT_INTERVIEW_ATTENDANCE_POLICY:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207852816663-Understanding-the-New-Interview-Attendance-Policy-for-Clipboard-Jobs",
  PLACEMENT_INTERVIEW_ATTENDANCE_SIMPLIFIED_POLICY:
    "https://workers.clipboardhealth.com/hc/en-us/articles/35226284724119-Understanding-the-Interview-Booking-Attendance-Policy",
  WORKER_REFERRAL_PROGRAM:
    "https://workers.clipboardhealth.com/hc/en-us/articles/29561079313175-How-the-Clipboard-Referral-Program-Works",
  SIGN_IC_AGREEMENT:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34207076910231-What-to-Do-If-You-Can-t-Sign-the-Independent-Contractor-Agreement",
  RENEW_CNA_LICENSE:
    "https://workers.clipboardhealth.com/hc/en-us/articles/32804421847703-CNA-License-Renewal-Guide",
  INVITE_REQUIRED:
    "https://workers.clipboardhealth.com/hc/en-us/articles/34208101399447-Why-Your-Clipboard-Account-May-Be-Restricted-or-Deactivated",
} as const;
